import { useState } from "react";
import { useFilterContext } from "../context/FilterProvider";

export default function SearchBar() {
	const [q, setQ] = useState("");
	const [state, dispatch] = useFilterContext();
	const { results } = state;

	const searchFor = (val) => {
		setQ(val);
		if (val.length === 0) {
			dispatch({ type: "UPDATE_FILTER", payload: results });
			return;
		}
		const formattedVal = val.toString().toLowerCase();
		const filteredVideos = results.filter((singleVid) => {
			const name = singleVid.name.toString().toLowerCase();
			return name.includes(formattedVal);
		});
		dispatch({ type: "UPDATE_FILTER", payload: filteredVideos });
	};

	return (
		<form>
			{/* <label htmlFor="search-form"> */}
			<input
				type="search"
				name="search-form"
				id="search-form"
				className="search-input"
				placeholder="Search"
				value={q}
				onChange={(e) => searchFor(e.target.value)}
			/>
			{/* </label> */}
			{/* <button onClick={searchFor} type="submit">
				Search
			</button> */}
		</form>
	);
}
